module.exports = __webpack_public_path__ + "static/media/grant_drop_in_grind_silverlake.bb2a6265.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grant_drop_in_grind_silverlake.png
// module id = 132
// module chunks = 0